import { JetView, plugins } from 'webix-jet'; // Importing JetView and plugins from webix-jet
import { devConfig } from 'config/config'; // Importing development configuration
import MenuView from 'jet-views/menu'; // Importing MenuView component
import ToolView from 'jet-views/toolbar'; // Importing ToolView component

/**
 * Represents the reports view.
 * @extends JetView
 */
export default class repotsView extends JetView {
    /**
     * Configures the layout of the reports view.
     * @returns {Object} The configuration object for the view.
     */
    config() {
        const _ = this.app.getService('locale')._; // Localization service
        const theme = this.app.config.theme; // Current theme configuration
        const screen = this.app.config.size; // Current screen size
        webix.ui.fullScreen(); // Set the UI to full screen mode

        return {
            type: 'clean', // Clean layout type
            view: 'form', // Form view
            id: 'a10', // Unique identifier for the form
            scroll: 'y', // Enable vertical scrolling
            rows: [
                {
                    type: 'wide', // Wide layout type
                    responsive: 'a10', // Responsive layout identifier
                    margin: 10, // Margin around the layout
                    cols: [
                        {
                            localId: 'inner:layout', // Local identifier for inner layout
                            gravity: 4, // Gravity for layout distribution
                            type: 'wide', // Wide layout type
                            rows: [
                                {
                                    view: 'tabbar', // Tabbar view for navigation
                                    localId: 'tabbar', // Local identifier for tabbar
                                    height: screen == 'small' ? 75 : 70, // Dynamic height based on screen size
                                    options: [
                                        // Tab options
                                        {
                                            id: 'partner.reports.depositReport', // Unique ID for deposit report tab
                                            value: _('Reporte de depósitos'), // Localized label
                                        },
                                        {
                                            id: 'partner.reports.autoexclusionUsers', // Unique ID for autoexclusion users tab
                                            value: _('Autoexclusiones de Usuario'), // Localized label
                                        },
                                        {
                                            id: 'partner.reports.casinoGamesReport', // Unique ID for casino games report tab
                                            value: _('Reporte de casino'), // Localized label
                                        },
                                        {
                                            id: 'partner.reports.balanceUsers', // Unique ID for balance users tab
                                            value: _('Reporte de Saldos'), // Localized label
                                        },
                                        {
                                            id: 'partner.reports.bonusReport', // Unique ID for bonus report tab
                                            value: _('Reporte de bonos'), // Localized label
                                        },
                                        {
                                            id: 'partner.reports.historicalCashFlow', // Unique ID for historical cash flow tab
                                            value: _('Flujo de Caja Histórico'), // Localized label
                                        },
                                        {
                                            id: 'partner.reports.informeGerencial', // Unique ID for managerial report tab
                                            value: _('Informe Gerencial'), // Localized label
                                        },
                                        {
                                            id: 'partner.reports.betsReport', // Unique ID for bets report tab
                                            value: _('Reporte de Apuestas'), // Localized label
                                        },
                                        {
                                            id: 'partner.reports.usuarioOnlineResumido', // Unique ID for summarized online users tab
                                            value: _('Usuario online Resumido'), // Localized label
                                        },
                                        {
                                            id: 'partner.reports.relationUserAggregator', // Unique ID for user-aggregator relation tab
                                            value: _('Usuario - Agregator'), // Localized label
                                        },
                                        {
                                            id: 'partner.reports.paidPendingAwards', // Unique ID for pending awards tab
                                            value: _('Premios pendientes por pagar'), // Localized label
                                        },
                                        {
                                            id: 'partner.reports.balanceAdjustments', // Unique ID for balance adjustments tab
                                            value: _('Reporte de Ajustes de Saldos'), // Localized label
                                        },
                                        {
                                            id: 'partner.reports.sportsTransactions', // Unique ID for sports transactions tab
                                            value: _('Reporte Trans. Sportbook'), // Localized label
                                        },
                                        {
                                            id: 'partner.reports.historyMovement', // Unique ID for history movement tab
                                            value: _('Reporte de  Movimientos Saldo'), // Localized label
                                        },
                                        {
                                            id: 'partner.reports.balanceHistory', // Unique ID for balance history tab
                                            value: _('Historico de  Saldos'), // Localized label
                                        },
                                        {
                                            id: 'partner.reports.balanceHistoryBetShop', // Unique ID for balance history at point of sale tab
                                            value: _('Historico Saldos Punto Venta'), // Localized label
                                        },
                                        {
                                            id: 'partner.reports.registeredDocument', // Unique ID for registered documents tab
                                            value: _('Documentos Registrados'), // Localized label
                                        },
                                        {
                                            id: 'partner.reports.comissionsReport', // Unique ID for commissions report tab
                                            value: _('Reporte Comisiones Global'), // Localized label
                                        },
                                        {
                                            id: 'partner.reports.wallets', // Unique ID for wallets report tab
                                            value: _('Reporte de billeteras'), // Localized label
                                        },
                                    ],
                                },
                                { $subview: true }, // Placeholder for subview
                            ],
                        },
                    ],
                },
            ],
        };
    }

    /**
     * Initializes the reports view.
     */
    init() {
        this.use(plugins.Menu, this.$$('tabbar')); // Use the Menu plugin with the tabbar
    }
}

// FILE DOCUMENTED
